// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"148c44a2","456":"62fec7b0","580":"097a3ba7","608":"0b6b25db","745":"3a0d456d","787":"50150f94","944":"19d3de8d"}[chunkId] + ".chunk.js";
};